import { Action } from '@ngrx/store';
import { DynamicRouting, DynamicRoutingResponse } from '../dynamic-routing.model';

export enum ActionTypes {
  SET_DYNAMIC_ROUTING_CONFIGURATION = 'SET_DYNAMIC_ROUTING_CONFIGURATION',
  SET_EXISTING_TUNNEL_CONFIGURATION = 'SET_EXISTING_TUNNEL_CONFIGURATION',
  ADD_DYNAMIC_ROUTING_CONFIGURATION = 'ADD_DYNAMIC_ROUTING_CONFIGURATION',
  UPDATE_DYNAMIC_ROUTING_CONFIGURATION = 'UPDATE_DYNAMIC_ROUTING_CONFIGURATION',
  DELETE_DYNAMIC_ROUTING_CONFIGURATION = 'DELETE_DYNAMIC_ROUTING_CONFIGURATION',
  CLEAR_DYNAMIC_ROUTING_CONFIGURATION = 'CLEAR_DYNAMIC_ROUTING_CONFIGURATION',
  CLEAR_EXISTING_TUNNEL_CONFIGURATION = 'CLEAR_EXISTING_TUNNEL_CONFIGURATION',
}

export class SetDynamicRoutingConfiguration implements Action {
  readonly type = ActionTypes.SET_DYNAMIC_ROUTING_CONFIGURATION;
  constructor(public payload: DynamicRoutingResponse) {}
}

export class SetExistingTunnelConfiguration implements Action {
  readonly type = ActionTypes.SET_EXISTING_TUNNEL_CONFIGURATION;
  constructor(public payload: any) {}
}

export class AddDynamicRoutingConfiguration implements Action {
  readonly type = ActionTypes.ADD_DYNAMIC_ROUTING_CONFIGURATION;
  constructor(public payload: DynamicRouting) {}
}

export class UpdateDynamicRoutingConfiguration implements Action {
  readonly type = ActionTypes.UPDATE_DYNAMIC_ROUTING_CONFIGURATION;
  constructor(public payload: DynamicRouting) {}
}

export class DeleteDynamicRoutingConfiguration implements Action {
  readonly type = ActionTypes.DELETE_DYNAMIC_ROUTING_CONFIGURATION;
  constructor(public payload: string[]) {}
}

export class ClearDynamicRoutingConfiguration implements Action {
  readonly type = ActionTypes.CLEAR_DYNAMIC_ROUTING_CONFIGURATION;
}

export class ClearExistingTunnelConfiguration implements Action {
  readonly type = ActionTypes.CLEAR_EXISTING_TUNNEL_CONFIGURATION;
}

export type Actions =
  | SetDynamicRoutingConfiguration
  | SetExistingTunnelConfiguration
  | AddDynamicRoutingConfiguration
  | UpdateDynamicRoutingConfiguration
  | DeleteDynamicRoutingConfiguration
  | ClearDynamicRoutingConfiguration
  | ClearExistingTunnelConfiguration;
